import React, { useEffect, useState } from 'react';
import { api } from '../services/api';

function decodeJwtPayload(token) {
  try {
    const parts = token.split('.');
    if (parts.length < 2) return null;
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(payload)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export default function Impersonate() {
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      setError('Missing token');
      return;
    }

    // Store token + minimal impersonation meta for banner
    api.setToken(token);

    const payload = decodeJwtPayload(token) || {};
    const meta = {
      impersonation: !!payload.impersonation,
      impersonator_user_id: payload.impersonator_user_id || null,
      dealer_id: payload.dealer_id || null,
      exp: payload.exp || null,
    };
    localStorage.setItem('impersonation_meta', JSON.stringify(meta));

    // Redirect into app
    window.location.href = '/';
  }, []);

  if (error) {
    return (
      <div style={{ padding: 24, fontFamily: 'system-ui' }}>
        <h2>Impersonation failed</h2>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div style={{ padding: 24, fontFamily: 'system-ui' }}>
      <h2>Logging you in…</h2>
    </div>
  );
}
